import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { getApiEventsByEventIdProductsOptions } from 'api/generated/@tanstack/react-query.gen';
import { useAppState } from 'lib/app-state';

/**
 * The products an event offers, and a way to the page adding them while there
 * are any and adding is allowed: `addProducts` is `undefined` otherwise.
 */
export const useEventProductsAdd = (eventId: number, allowAdd: boolean) => {
  const router = useRouter();
  const appState = useAppState();
  const {
    data
  } = useQuery({
    ...getApiEventsByEventIdProductsOptions({
      path: {
        eventId
      }
    }),
    enabled: eventId > 0
  });
  const offered = data?.products ?? undefined;
  const canAdd = allowAdd && (offered?.length ?? 0) > 0;
  const addProducts = canAdd ? () => {
    appState.setIsCartOpen(false);
    router.push(`/products/${eventId}`);
  } : undefined;
  return {
    offered,
    addProducts
  };
};